import React, { useContext, useEffect } from 'react';
import '../../assets/dsgov/css/components/header.css';
import BRHeader from '../../assets/dsgov/js/components/header';
import Logo from '../../assets/logo-serprobots-big.png';
import BotContext from '../../context/FlowContext';
import { AvatarPanel } from './AvatarPanel';
import { BackToBotsButton } from './BackToBotsButton';
import './Header.css';
import PublishButton from './PublishButton/PublishButton';
import { SavingStatusPanel } from './SavingStatusPanel';

export default function Header(props) {
  const botContext = useContext(BotContext);

  useEffect(() => {
    const header = window.document.querySelector('.br-header');
    if (header) new BRHeader('br-header', header);
  });

  if (!botContext.bots) return null;
  const botName = botContext.bots[props.selectedBotId] ? botContext.bots[props.selectedBotId].name : '';

  return (
    <header className="br-header" sticky="" data-compact="" data-no-logo="">
      <div className="container-xl">
        <div className="flex-container">
          <div className="logo">
            <img src={Logo} alt="logo" />
          </div>
          <div className="actions">
            <div
              className="links"
              style={props.selectedBotId ? {
                visibility: 'visible',
              } : {
                visibility: 'hidden',
              }}
            >
              <ul>
                <SavingStatusPanel selectedBotId={props.selectedBotId} />
                <PublishButton />
              </ul>
            </div>
            <AvatarPanel />
          </div>

          <div className="menu ">
            <div className="logo2">
              <img src={Logo} alt="logo" />
            </div>
            <BackToBotsButton
              botName={botName}
              show={!!props.selectedBotId}
            />
          </div>
        </div>

      </div>
    </header>
  );
}
